import type { LogObject } from '../types/LogObject';
import LogLevel from '../constants/levels';
import { log } from './log';

export function debug(logObject: LogObject, applicationUid: string | null = null) {
    log({
        level: LogLevel.DEBUG,
        ...logObject
    });
}
